import { ArrowUpRight, Star } from "lucide-react";
import { KNOWN_FOR, LINKS, REVIEWS } from "../data/content";
import { Eyebrow, Reveal } from "./Reveal";

const Stars = () => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={14} className="fill-[#FFB800] text-neon" />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="reviews" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="reviews-section">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <Reveal>
          <Eyebrow>Word on the street</Eyebrow>
          <h2 className="mt-4 max-w-xl font-serif text-2xl tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Rated <em className="italic text-neon">4.7</em> by people who actually showed up.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="text-right" data-testid="reviews-aggregate">
            <p className="font-serif text-6xl text-cream">
              4.7<span className="text-neon">★</span>
            </p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-mist">
              622 dining ratings · Zomato
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-8 flex flex-wrap gap-2.5" data-testid="reviews-known-for">
          {KNOWN_FOR.map((k) => (
            <span
              key={k}
              className="rounded-full border border-leafglow/40 bg-leaf/20 px-4 py-1.5 text-xs tracking-wide text-sage"
            >
              {k}
            </span>
          ))}
        </div>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.author} delay={i * 0.08} className="h-full">
            <article
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col rounded-2xl border border-cream/8 bg-moss p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-neon/30 hover:shadow-[0_20px_50px_rgba(255,184,0,0.08)]"
            >
              <Stars />
              <p className="mt-4 flex-1 text-sm leading-relaxed text-sage">“{r.text}”</p>
              <footer className="mt-6 border-t border-cream/8 pt-4">
                <p className="font-medium text-cream">{r.author}</p>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.18em] text-mist">
                  {r.date} · via Zomato
                </p>
              </footer>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <a
          href={LINKS.zomato}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-zomato-link"
          className="group mt-8 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.22em] text-neon transition-colors hover:text-cream"
        >
          Read all 600+ ratings on Zomato
          <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
      </Reveal>
    </section>
  );
}
